import type { CatalogSet, Definition, View, Words } from './types'

/**
 * Seturile din catalog, asezate pe familii pentru pasul 1 al constructorului
 * ("Ce date?"). Campul `module` din catalog spune modulul care da DREPTUL
 * (costurile si CMDB stau sub inventoree), nu familia pe care o cauta omul,
 * deci asezarea se face dupa prefixul cheii, cu modulul ca plasa.
 */

export interface SetGroup {
  key: string
  label: Words
}

export const SET_GROUPS: SetGroup[] = [
  { key: 'desk', label: { ro: 'Easeedesk', en: 'Easeedesk' } },
  { key: 'devices', label: { ro: 'Aparate', en: 'Devices' } },
  { key: 'software', label: { ro: 'Software', en: 'Software' } },
  { key: 'cmdb', label: { ro: 'CMDB', en: 'CMDB' } },
  { key: 'costs', label: { ro: 'Costuri', en: 'Costs' } },
  { key: 'monitoring', label: { ro: 'Monitorizare', en: 'Monitoring' } },
  { key: 'security', label: { ro: 'Securitate', en: 'Security' } },
  { key: 'productivity', label: { ro: 'Productivitate', en: 'Productivity' } },
  { key: 'admin', label: { ro: 'Administrare', en: 'Administration' } },
  { key: 'other', label: { ro: 'Altele', en: 'Other' } },
]

const BY_PREFIX: [string, string][] = [
  ['easeedesk.', 'desk'],
  ['cmdb.', 'cmdb'],
  ['discovery.', 'cmdb'],
  ['business.', 'cmdb'],
  ['costs.', 'costs'],
  ['softsee.', 'software'],
  ['opteemum.', 'devices'],
  ['devices.', 'devices'],
  ['inventoree.', 'devices'],
  ['proactivitee.', 'monitoring'],
  ['securitee.', 'security'],
  ['productivitee.', 'productivity'],
  ['settings.', 'admin'],
]

export function setGroup(set: CatalogSet): string {
  for (const [prefix, group] of BY_PREFIX) if (set.key.startsWith(prefix)) return group
  for (const [prefix, group] of BY_PREFIX) if (`${set.module}.` === prefix) return group
  return 'other'
}

/**
 * Vederea care se potriveste formei: lista -> tabel, o cifra -> cifra,
 * pe zile/luni -> linie, pe altceva -> bare. Se pune cand se schimba forma
 * (pasii 2 si 3); omul o poate schimba dupa, la pasul 5.
 */
export function fittingView(def: Definition): View {
  if ((def.measures?.length ?? 0) === 0 && (def.group_by?.length ?? 0) === 0) return 'table'
  const first = def.group_by?.[0]
  if (!first) return 'kpi'
  return first.bucket ? 'line' : 'bar'
}
